import { useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { CalendarX, Check } from "@phosphor-icons/react";

const FIELD_LABELS = {
  mass_start_date: "Start", mass_end_date: "Ende", mid_invoice_date: "Zwischenrechnung",
  final_invoice_date: "Schlussrechnung", sent_date: "Versanddatum", paid_date: "Zahlungsdatum",
};

const DateRow = ({ it, onFixed }) => {
  const [val, setVal] = useState(it.suggestion || "");
  const fix = async () => {
    try {
      await api.post("/maintenance/date-audit/fix", { collection: it.collection, id: it.id, field: it.field, value: val });
      toast.success(`${it.customer_name}: Datum korrigiert`);
      onFixed();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Korrektur fehlgeschlagen");
    }
  };
  const key = `${it.id}-${it.field}`;
  return (
    <tr className="border-b border-[#F1F5F9] last:border-0" data-testid={`date-audit-row-${key}`}>
      <td className="px-3 py-2 font-medium text-[#1F242E]">{it.customer_name}<span className="ml-2 text-[10px] text-[#5B6371]">{it.type}</span></td>
      <td className="px-3 py-2 text-sm">{FIELD_LABELS[it.field] || it.field}</td>
      <td className="px-3 py-2 text-sm text-[#FF6B5C] font-mono">{it.value}</td>
      <td className="px-3 py-2">
        <input type="date" min="2020-01-01" max="2100-12-31" className="field !py-1 !text-xs" value={val}
          onChange={(e) => setVal(e.target.value)} data-testid={`date-audit-input-${key}`} />
      </td>
      <td className="px-3 py-2 text-right">
        <button type="button" onClick={fix} disabled={!val}
          className="inline-flex items-center gap-1 text-xs font-medium px-3 py-1.5 rounded-md bg-[#0AA09E] hover:bg-[#088987] text-white disabled:opacity-50"
          data-testid={`date-audit-fix-${key}`}>
          <Check size={12} /> Korrigieren
        </button>
      </td>
    </tr>
  );
};

export const DateAuditPanel = () => {
  const [data, setData] = useState(null);
  const check = async () => {
    try {
      const { data } = await api.get("/maintenance/date-audit");
      setData(data);
    } catch {
      toast.error("Prüfung fehlgeschlagen");
    }
  };
  return (
    <div className="bg-white border border-[#E5E7EB] rounded-lg p-5 space-y-4" data-testid="date-audit-panel">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <div className="font-semibold text-[#1F242E] flex items-center gap-2"><CalendarX size={16} /> Ungültige Datumswerte</div>
          <div className="text-xs text-[#5B6371]">Findet Tippfehler wie Jahr „0026" in AVGS- und FBW-Einträgen.</div>
        </div>
        <button type="button" onClick={check}
          className="bg-[#1F242E] hover:bg-black text-white text-sm font-medium rounded-md px-4 py-2"
          data-testid="date-audit-check-btn">Datumswerte prüfen</button>
      </div>
      {data && data.count === 0 && <div className="text-sm text-[#0AA09E] font-medium" data-testid="date-audit-clean">Alle Datumswerte sind gültig.</div>}
      {data && data.count > 0 && (
        <div className="overflow-x-auto border border-[#E5E7EB] rounded-md">
          <table className="w-full text-sm" data-testid="date-audit-table">
            <thead>
              <tr className="text-xs uppercase tracking-widest text-[#5B6371] bg-[#F8FAFC] border-b border-[#E5E7EB]">
                <th className="text-left px-3 py-2 font-medium">Kunde</th>
                <th className="text-left px-3 py-2 font-medium">Feld</th>
                <th className="text-left px-3 py-2 font-medium">Aktuell</th>
                <th className="text-left px-3 py-2 font-medium">Neu</th>
                <th className="px-3 py-2"></th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((it) => <DateRow key={`${it.id}-${it.field}`} it={it} onFixed={check} />)}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
